import React, { Component } from 'react'

import './HeaderContainer.css';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import menuDatas from '../content/MenuDatas';

import MenuItemCustom from './MenuItemCustom';

class HeaderContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            auth: true,
            anchorEl: null,
        };
        this.handleDrawerClick = this.handleDrawerClick.bind(this);
    }

    handleDrawerClick() {
        if (this.state.open === false)
            this.setState({ open: true });
        else
            this.setState({ open: false });
    }

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    prepareNavBarre() {
        var retour = [];
        Object.keys(menuDatas).forEach(menu => {
            if (menuDatas[menu].menu) {
                retour.push(
                    <MenuItemCustom key={menuDatas[menu].path} libelle={menuDatas[menu].label} icon={menuDatas[menu].icon} closePanel={this.handleDrawerClick} url={menuDatas[menu].path} />
                );
            }
        })
        return retour;
    }

    getMenu() {
        // eslint-disable-next-line
        const { auth, anchorEl } = this.state;
        const open = Boolean(anchorEl);
        var navBarre = this.prepareNavBarre();
        return (
            <div id="menu">
                <AppBar position="static" className="menuBarre">
                    <Toolbar className="menuToolbar">
                        <IconButton color="inherit" aria-label="Menu" onClick={this.handleDrawerClick} >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className="menuBarreTitre">
                            Mon appli de gestion
                        </Typography>
                        <div className="menuBarreAuth">
                            <IconButton
                                aria-haspopup="true"
                                onClick={this.handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="menuBarreAuth"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={open}
                                onClose={this.handleClose}
                            >
                                <MenuItem onClick={this.handleClose}>Profile</MenuItem>
                                <MenuItem onClick={this.handleClose}>My account</MenuItem>
                            </Menu>
                        </div>
                    </Toolbar>
                </AppBar>
                <Drawer open={this.state.open} onClose={this.handleDrawerClick} className="navigationMenu">
                    <div tabIndex={0} role="button" onClick={this.handleDrawerClick} onKeyDown={this.handleDrawerClick}>
                        <List>
                            {navBarre}
                        </List>
                    </div>
                </Drawer>
            </div>
        )
    }

    render() {
        return (
            <div id="head">
                {this.getMenu()}
            </div>
        )
    }
}

export default HeaderContainer


// WEBPACK FOOTER //
// ./src/components/header/HeaderContainer.js